// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from 'axios';

import axiosInstance from './axiosInstance';

/**
 * @typedef {Object} ResponseGetCollectorAccounts
 * @property {Array.<Object>} data - Lista de cuentas recaudadoras
 * @property {Number} current_page - Pagina Actual
 * @property {Number} per_page - Cantidad items por pagina
 * @property {Number} total_pages - Total de paginas
 * @property {Number} total_elements - Total de Items
 */

/**
 * @typedef {Object} FiltersObjectGetCollectorAccounts
 * @property {Number} [perPage] - Cantidad de recursos por pagina
 * @property {Number} [page] - Pagina Actual
 * @property {String} [email] - Filtrar por email de usuario asignado
 * @property {Boolean} [unassigned] - Mostrar solo cuentas sin usuario asignado
 */

/**
 * Obtener la lista de cuentas recaudadoras (mirror)
 * @param {FiltersObjectGetCollectorAccounts} [filters] - Filtros
 * @returns {Promise<AxiosResponse<ResponseGetCollectorAccounts>>} Listado de cuentas recaudadoras
 */
const getCollectorAccounts = (filters = {}) => {
  const { perPage, page, email, unassigned } = filters;

  return axiosInstance.get('/internal/admin/collector_accounts', {
    params: {
      per_page: perPage,
      page,
      email: email || undefined,
      unassigned: unassigned || undefined,
    },
  });
};

export default getCollectorAccounts;
